
const short = (int) => {
    if(int) {return int.length > 55 ? `${int.slice(0,55 )}...` : int}
}

export default short